/* Изменяемое состояние раздела с подпиской React. Объект S остаётся тем же (его читают другие модули прототипа: BotProfile читает BotRewards.S),
   update() меняет его и будит подписчиков. */
import { useSyncExternalStore } from 'react';

export interface MutableStore<S extends object> {
  S: S;
  update(fn: (s: S) => void): void;
  subscribe(fn: () => void): () => void;
  version(): number;
}

export function mutableStore<S extends object>(S: S): MutableStore<S> {
  let v = 0;
  const subs = new Set<() => void>();
  return {
    S,
    update(fn) {
      fn(S);
      v++;
      subs.forEach(f => f());
    },
    subscribe(fn) {
      subs.add(fn);
      return () => subs.delete(fn);
    },
    version: () => v,
  };
}

/** Перерисовка при каждом update(); возвращает сам объект состояния */
export function useStore<S extends object>(st: MutableStore<S>): S {
  useSyncExternalStore(st.subscribe, st.version);
  return st.S;
}
